import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../config/httpConfig";

const amount = localStorage.getItem("invUser")
  ? JSON.parse(localStorage.getItem("invUser")).amount
  : "";

export const getAccountBalanceInfo = createAsyncThunk(
  "manageFunds/getAccountBalanceInfo",
  async (orgId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/investor/getAccountBalanceInfo?orgId=${orgId}`
      );
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getBankDetailsByOrgId = createAsyncThunk(
  "manageFunds/getBankDetailsByOrgId",
  async (orgId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/investor/getBankDetailsByOrgId?orgId=${orgId}`
      );
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getEscrowDetailsByOrgId = createAsyncThunk(
  "manageFunds/getEscrowDetailsByOrgId",
  async (orgId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/investor/getEscrowDetailsByOrgId?orgId=${orgId}`
      );
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getAccountTxnHistory = createAsyncThunk(
  "manageFunds/getAccountTxnHistory",
  async (params, { rejectWithValue }) => {
    const { withdraw, deposit, dealPurchase, dealRepayment } = params;
    try {
      const response = await axios.get(
        `/api/investor/getAccountTxnHistory?withdraw=${withdraw}&deposit=${deposit}&dealPurchase=${dealPurchase}&dealRepayment=${dealRepayment}`
      );
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getBalanceByOrgId = createAsyncThunk(
  "manageFunds/getBalanceByOrgId",
  async (orgId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/investor/getBalanceByOrgId?orgId=${orgId}`
      );
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const withdraw = createAsyncThunk(
  "manageFunds/withdraw",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `/api/investor/withdraw`, payload
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const sendWithdrawOtp = createAsyncThunk(
  "manageFunds/sendWithdrawOtp",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/investor/withdraw/sendOtp`);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const manageFundSlice = createSlice({
  name: "manageFunds",
  initialState: {
    accBalance: { amount: amount },
    availableBalance: {},
    bankDetailsData: [],
    escrowBankDetailsData: {},
    txnHisLoading: false,
    txnHistoryData: [],
    loading: false,
    error: null,
    withdrawLoading: false,
    withdrawError: null,
    withdrawOtpLoading: false,
    withdrawOtpError: null,
    withdrawOtpData: null,
  },

  extraReducers: (builder) => {
    builder.addCase(getBalanceByOrgId.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getBalanceByOrgId.fulfilled, (state, action) => {
      state.loading = false;
      state.accBalance = action.payload;
      state.error = null;
    });
    builder.addCase(getBalanceByOrgId.rejected, (state, action) => {
      state.loading = false;
      state.accBalance = [];
      state.error = action.payload;
    });

    builder.addCase(getAccountBalanceInfo.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getAccountBalanceInfo.fulfilled, (state, action) => {
      state.loading = false;
      state.availableBalance = action.payload;
      state.error = null;
    });
    builder.addCase(getAccountBalanceInfo.rejected, (state, action) => {
      state.loading = false;
      state.availableBalance = [];
      state.error = action.payload;
    });

    builder.addCase(getBankDetailsByOrgId.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getBankDetailsByOrgId.fulfilled, (state, action) => {
      state.loading = false;
      state.bankDetailsData = action.payload;
      state.error = null;
    });
    builder.addCase(getBankDetailsByOrgId.rejected, (state, action) => {
      state.loading = false;
      state.bankDetailsData = [];
      state.error = action.payload;
    });

    builder.addCase(getEscrowDetailsByOrgId.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getEscrowDetailsByOrgId.fulfilled, (state, action) => {
      state.loading = false;
      state.escrowBankDetailsData = action.payload;
      state.error = null;
    });
    builder.addCase(getEscrowDetailsByOrgId.rejected, (state, action) => {
      state.loading = false;
      state.escrowBankDetailsData = {};
      state.error = action.payload;
    });

    builder.addCase(getAccountTxnHistory.pending, (state) => {
      state.txnHisLoading = true;
      state.error = null;
    });
    builder.addCase(getAccountTxnHistory.fulfilled, (state, action) => {
      state.txnHisLoading = false;
      state.txnHistoryData = action.payload;
      state.error = null;
    });
    builder.addCase(getAccountTxnHistory.rejected, (state, action) => {
      state.txnHisLoading = false;
      state.txnHistoryData = [];
      state.error = action.payload;
    });

    builder.addCase(withdraw.pending, (state) => {
      state.withdrawLoading = true;
      state.withdrawError = null;
    });
    builder.addCase(withdraw.fulfilled, (state, action) => {
      state.withdrawLoading = false;
      state.withdrawError = null;
    });
    builder.addCase(withdraw.rejected, (state, action) => {
      state.withdrawLoading = false;
      state.withdrawError = action.payload;
    });

    builder.addCase(sendWithdrawOtp.pending, (state) => {
      state.withdrawOtpLoading = true;
      state.withdrawOtpError = null;
    });
    builder.addCase(sendWithdrawOtp.fulfilled, (state, action) => {
      state.withdrawOtpLoading = false;
      state.withdrawOtpError = null;
      state.withdrawOtpData = action.payload?.response || action.payload || null;
    });
    builder.addCase(sendWithdrawOtp.rejected, (state, action) => {
      state.withdrawOtpLoading = false;
      state.withdrawOtpError = action.payload;
      state.withdrawOtpData = null;
    });
  },
  reducers: {
    clearWithdrawOtpState: (state) => {
      state.withdrawOtpLoading = false;
      state.withdrawOtpError = null;
      state.withdrawOtpData = null;
    },
  },
});

export const { clearWithdrawOtpState } = manageFundSlice.actions;

export default manageFundSlice.reducer;
